/**
 * Builds the merchant reference used to route package-payment webhooks. UUIDv4
 * contributes 122 random bits, preventing enumeration of paid package lookups.
 */
export function createPackagePurchaseReference() {
  return `PKG-${globalThis.crypto.randomUUID()}`.toUpperCase();
}
